export default {
    data() {
        return {
            pending: false,
            items: [],
            params: {},
            abortController: null
        };
    },
    watch: {
        params: {
            handler(newParamsValue) {
                this.fetchData(newParamsValue);
            },
            deep: true
        }
    },
    mounted() {
        if (this.lazy) return;
        this.fetchData(this.params);
    },
    computed: {
        showNoResult() {
            if (this.pending) {
                return false;
            }

            if (this.lazy && !this.items.length) {
                return false;
            }

            return !this.items.length;
        },
    },
    methods: {
        fetchData(params = {}) {
            if (!this.apiUrl) {
                return;
            }

            if (this.pending) {
                if (this.abortController) {
                    this.abortController.abort()
                    this.abortController = null
                }
            }

            if (this.lazy !== undefined) {
                this.lazy = false;
            }

            this.pending = true;
            this.abortController = new AbortController

            this.axios
                .get(this.apiUrl,{
                    params,
                    signal: this.abortController.signal
                })
                .then(({data}) => this.setData(data.data || data))
                .catch(e => {
                    if (!e.response) {
                        throw e;
                    }

                    if (e.response.status === 404) {
                        this.onNotFound();
                    }
                })
                .finally(() => {
                    this.pending = false;
                    this.abortController = null
                });

        },

        setData(items) {
            this.items = items;
        },

        onNotFound() {
            //
        }
    },
};
